"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require("../../utils");

var _semanticUiReact = require("semantic-ui-react");

var _uuid = require("uuid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function processValue(_ref, data) {
  var type = _ref.type,
      items = _ref.items;

  if (data === "") {
    return undefined;
  } else if (type === "array" && items && ["number", "integer"].includes(items.type)) {
    return data.map(_utils.asNumber);
  } else if (type === "boolean") {
    return data === "true";
  } else if (type === "number") {
    return (0, _utils.asNumber)(data);
  }
  return data;
} /**
   * This is a silly limitation in the DOM where option change event values are
   * always retrieved as strings.
   */


function getValue(data, multiple) {
  if (multiple && data !== undefined && !(data.value instanceof Array)) {
    return [data.value];
  }

  return data.value;
}

function SelectWidget(props) {
  var schema = props.schema,
      id = props.id,
      options = props.options,
      value = props.value,
      required = props.required,
      disabled = props.disabled,
      readOnly = props.readOnly,
      multiple = props.multiple,
      autoFocus = props.autoFocus,
      _onChange = props.onChange,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      placeholder = props.placeholder;
  var enumOptions = options.enumOptions;

  var dropdownOptions = [];

  enumOptions.map(function (_ref2, i) {
    var value = _ref2.value,
        label = _ref2.label;

    dropdownOptions.push({ key: i, value: value, text: label });
  });

  return _react2.default.createElement(_semanticUiReact.Dropdown, {
    key: (0, _uuid.v4)(),
    search: true,
    selection: true,
    placeholder: placeholder,
    options: dropdownOptions,
    multiple: multiple,
    defaultValue: value,
    disabled: disabled,
    required: required,
    autoFocus: autoFocus,
    readOnly: readOnly,
    onBlur: onBlur && function (event, self) {
      var newValue = getValue(self, multiple);
      onBlur(id, processValue(schema, newValue));
    },
    onFocus: onFocus && function (event, self) {
      var newValue = getValue(self, multiple);
      onFocus(id, processValue(schema, newValue));
    },
    onChange: function onChange(event, self) {
      var newValue = getValue(self, multiple);
      _onChange(processValue(schema, newValue));
    },
    onLabelClick: function onLabelClick(event, self) {
      var newValue = getValue(self, multiple);
      _onChange(processValue(schema, newValue));
    }
  });
}

SelectWidget.defaultProps = {
  autoFocus: false
};

if (process.env.NODE_ENV !== "production") {
  SelectWidget.propTypes = {
    schema: _propTypes2.default.object.isRequired,
    id: _propTypes2.default.string.isRequired,
    options: _propTypes2.default.shape({
      enumOptions: _propTypes2.default.array
    }).isRequired,
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.array]),
    required: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    readOnly: _propTypes2.default.bool,
    multiple: _propTypes2.default.bool,
    autoFocus: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    onFocus: _propTypes2.default.func
  };
}

exports.default = SelectWidget;